import simpleSoilAttribute from './simpleSoilAttribute';

export const PONDING_FREQUENCY_CLASS = simpleSoilAttribute({
  key: 'Ponding Frequency Class',
  ruleId: '13',
  shortFormData: {
    AggregationMethod: 'Dominant Condition',
    BeginningMonth: 'January',
    EndingMonth: 'December',
  },
});
